import { Component } from "../components/component";
import { uuid } from "./uuid";

export class ComponentDefinition {
    componentName: string;
    factory: (element: HTMLElement, blazorElement: any) => Component;
}

export class ComponentService {
    components = new Map<string, ComponentDefinition>();
    componentBindings = new Map<string, Component>();

    attachComponent(componentName: string, htmlElement: HTMLElement, blazorElement): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            var cd = this.components.get(componentName);

            console.log("Element connected", htmlElement);

            if(cd == null) {
                reject();

                throw `Component with name ${componentName} is not registered`; 
            }

            var instance = cd.factory(htmlElement, blazorElement);
            var id = uuid();

            this.componentBindings.set(id, instance);

            instance.initialize();

            resolve(id);
        });
    }

    invokeMethod(componentId: string, methodName: string, ...params: any[]) {
        console.log(`Invoking method ${methodName} for component '${componentId}' with parameters`, params);

        var cb = this.componentBindings.get((componentId));

        if(cb == null) {
            throw `Component with id ${componentId} doesn't exist`;
        }

        cb[methodName](...params);
    }

    registerComponent(componentName: string, componentFactory: (element: HTMLElement, blazorElement: any) => Component) {
        this.components.set(componentName, {
            componentName: componentName,
            factory: componentFactory
        });
    }
}